import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
// import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import clientConfig from "../../config/client";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";

const RelationsList = (props) => {
    const { locale } = { ...clientConfig };
    const rows =
        props.relations &&
        Object.entries(props.relations).map((entry) => {
            const [relatedEntity, relationConfig] = [...entry];
            if (relationConfig.target) return null;
            const [options, setOptions] = useState([]);
            const [loading, setLoading] = useState(false);

            // init relation routes between current item and other entity type
            const currentItemRelations = props.relationsDataSource(
                props.id,
                relatedEntity,
            );
            const [currentValue, setCurrentValue] = useState([]);

            const label = relationConfig.labels
                ? relationConfig.labels[locale]
                : relatedEntity;

            const lookup = async (query) => {
                if (query.length < 3) return setOptions([]);
                if (query.length > 3) return;
                setLoading(true);
                const items = (await currentItemRelations.query(query)).data;
                setLoading(false);
                if (!Array.isArray(items)) return;
                //Supress invalid value match warning
                setOptions([...items, ...currentValue]);
            };

            useEffect(() => {
                if (!props.id) return;
                (async () => {
                    const related = await currentItemRelations.getRelated();

                    setLoading(false);

                    if (Array.isArray(related)) setCurrentValue(related);
                })();
            }, []);

            useEffect(() => {
                if (!open) {
                    setOptions([]);
                }
            }, [open]);

            const handleUpdate = (event, value, reason) => {
                // Disable removing items on Backspace
                if (event.keyCode === 8) return;

                if (reason === "select-option") {
                    const newItem = [...value].pop();

                    if (props.id) {
                        currentItemRelations.addRelation(newItem.id);
                    }
                }
                if (reason === "remove-option") {
                    const ids = value.map((item) => item.id);
                    const removedItem = currentValue.filter(
                        (item) => ids.indexOf(item.id) === -1,
                    );
                    if (removedItem.length < 1) return;
                    if (props.id) {
                        currentItemRelations.removeRelation(removedItem[0].id);
                    }
                }

                if (props.setRelationsValue) {
                    props.setRelationsValue(
                        relatedEntity,
                        value.map((item) => item.id),
                    );
                }

                return setCurrentValue(value);
            };

            return (
                <TableRow key={relatedEntity}>
                    <TableCell
                        style={{
                            width: "250px",
                            borderBottom: "none",
                        }}
                    >
                        {label}
                    </TableCell>
                    <TableCell style={{ borderBottom: "none" }}>
                        <Autocomplete
                            getOptionSelected={(option, value) => {
                                return option.id == value.id;
                            }}
                            ChipProps={{
                                color: "primary",
                                variant: "outlined",
                            }}
                            onChange={handleUpdate}
                            loading={loading}
                            multiple
                            options={options}
                            getOptionLabel={(option) => option.name}
                            defaultValue={[]}
                            value={currentValue}
                            variant="standard"
                            disableClearable={true}
                            filterSelectedOptions
                            loadingText="..."
                            noOptionsText={"Ничего не найдено"}
                            renderInput={(params) => (
                                <TextField
                                    onBlur={(e) => (e.target.value = "")}
                                    placeholder="Введите наименование..."
                                    {...params}
                                    onChange={(e) => lookup(e.target.value)}
                                    variant="standard"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loading ? (
                                                    <CircularProgress
                                                        color="inherit"
                                                        size={20}
                                                    />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </TableCell>
                </TableRow>
            );
        });

    return (
        <TableContainer>
            <Table>
                <TableBody>{rows}</TableBody>
            </Table>
        </TableContainer>
    );
};

RelationsList.defaultProps = {};
RelationsList.propTypes = {
    relations: PropTypes.object.isRequired,
    relationsDataSource: PropTypes.func.isRequired,
    setRelationsValue: PropTypes.func,
    id: PropTypes.number,
};
export default RelationsList;
